import React, { createContext } from 'react'
import { IAssemblyType, IContentfulProviderContext } from '../types'

/** @public */
export const ContentfulContext: React.Context<IAssemblyType> = createContext({})

/** @public */
const ContentfulProvider = ({ contentful, children }: IContentfulProviderContext) => {
  return <ContentfulContext.Provider value={contentful}>{children}</ContentfulContext.Provider>
}

ContentfulProvider.displayName = 'ContentfulProvider'
ContentfulContext.displayName = 'ContentfulContext'

export default ContentfulProvider
